module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 122);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("@splunk/themes");

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 11:
/***/ (function(module, exports) {

module.exports = require("@splunk/react-ui/Clickable");

/***/ }),

/***/ 122:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "default", function() { return /* reexport */ src_ButtonSimple_ButtonSimple; });

// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(2);
var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_);

// EXTERNAL MODULE: external "prop-types"
var external_prop_types_ = __webpack_require__(1);
var external_prop_types_default = /*#__PURE__*/__webpack_require__.n(external_prop_types_);

// EXTERNAL MODULE: external "@splunk/ui-utils/i18n"
var i18n_ = __webpack_require__(5);

// EXTERNAL MODULE: external "@splunk/themes"
var themes_ = __webpack_require__(0);

// EXTERNAL MODULE: external "@splunk/react-ui/ScreenReaderContent"
var ScreenReaderContent_ = __webpack_require__(14);
var ScreenReaderContent_default = /*#__PURE__*/__webpack_require__.n(ScreenReaderContent_);

// EXTERNAL MODULE: external "styled-components"
var external_styled_components_ = __webpack_require__(3);
var external_styled_components_default = /*#__PURE__*/__webpack_require__.n(external_styled_components_);

// EXTERNAL MODULE: external "@splunk/react-ui/Clickable"
var Clickable_ = __webpack_require__(11);
var Clickable_default = /*#__PURE__*/__webpack_require__.n(Clickable_);

// CONCATENATED MODULE: ./src/ButtonSimple/prismaStyles.ts


var common = Object(external_styled_components_["css"])(["", " cursor:pointer;position:relative;&:focus,&:hover{z-index:3;}"], themes_["mixins"].reset('block'));
/* Setting border-radius to 0.1px creates a rounded shadow, */

var appendPrepend = Object(external_styled_components_["css"])(["", " ", ""], function (_ref) {
  var $append = _ref.$append;
  return $append && Object(external_styled_components_["css"])(["border-top-right-radius:0.1px;border-bottom-right-radius:0.1px;border-right:none;"]);
}, function (_ref2) {
  var $prepend = _ref2.$prepend;
  return $prepend && Object(external_styled_components_["css"])(["border-top-left-radius:0.1px;border-bottom-left-radius:0.1px;"]);
});
var prismaTransparent = Object(external_styled_components_["css"])(["", " ", " ", " &:not([disabled]){color:", ";transition:background-color 0.2s,border 0.2s,box-shadow 0.2s,text-decoration 0.2s;&:hover{background-color:", ";border-color:", ";", "}", " ", " &:active{background-color:", ";transition:none;}&:focus{background-color:", ";", " &:active{background-color:", ";}}}&[disabled]{border-color:", ";color:", ";cursor:not-allowed;", "}"], common, Object(themes_["pickVariant"])('$variant', {
  prismaSecondary: Object(external_styled_components_["css"])(["border-radius:calc(", " / 2);font-weight:", ";"], themes_["variables"].inputHeight, themes_["variables"].fontWeightSemiBold),
  prismaDefault: Object(external_styled_components_["css"])(["border:1px solid ", ";border-radius:calc(", " / 2);font-weight:", ";"], themes_["variables"].interactiveColorBorder, themes_["variables"].inputHeight, themes_["variables"].fontWeightSemiBold),
  prismaToggle: Object(external_styled_components_["css"])(["border:1px solid ", ";border-radius:", ";font-weight:normal;"], themes_["variables"].interactiveColorBorder, themes_["variables"].borderRadius)
}), appendPrepend, themes_["variables"].contentColorActive, themes_["variables"].interactiveColorOverlayHover, themes_["variables"].interactiveColorBorderHover, Object(themes_["pickVariant"])('$variant', {
  prismaSecondary: Object(external_styled_components_["css"])(["box-shadow:", ";"], themes_["variables"].hoverShadow),
  prismaDefault: Object(external_styled_components_["css"])(["box-shadow:", ";"], themes_["variables"].hoverShadow)
}), function (_ref3) {
  var $selected = _ref3.$selected;
  return $selected && Object(external_styled_components_["css"])(["background-color:", ";border-color:", ";&:hover{background-color:", ";}"], themes_["variables"].interactiveColorOverlaySelected, themes_["variables"].interactiveColorBorderDisabled, themes_["mixins"].overlayColors(themes_["variables"].interactiveColorOverlaySelected, themes_["variables"].interactiveColorOverlayHover));
}, function (_ref4) {
  var $error = _ref4.$error;
  return $error && Object(external_styled_components_["css"])(["border-color:", ";&:hover{border-color:", ";}"], themes_["variables"].accentColorNegative, themes_["variables"].accentColorNegative);
}, themes_["variables"].interactiveColorOverlayActive, themes_["variables"].interactiveColorOverlayHover, Object(themes_["pickVariant"])('$variant', {
  prismaSecondary: Object(external_styled_components_["css"])(["box-shadow:", ";"], themes_["variables"].focusShadow),
  prismaDefault: Object(external_styled_components_["css"])(["box-shadow:", ";"], themes_["variables"].focusShadow),
  prismaToggle: Object(external_styled_components_["css"])(["border-color:", ";"], themes_["variables"].interactiveColorPrimary)
}), themes_["variables"].interactiveColorOverlayActive, themes_["variables"].interactiveColorBorderDisabled, themes_["variables"].contentColorDisabled, function (_ref5) {
  var $selected = _ref5.$selected;
  return $selected && Object(external_styled_components_["css"])(["background-color:", ";"], themes_["mixins"].overlayColors(themes_["variables"].interactiveColorBackgroundDisabled, themes_["variables"].interactiveColorOverlaySelected));
});
var disabledFillStyles = Object(external_styled_components_["css"])(["&[disabled]{border-color:", ";color:", ";background-color:", ";cursor:not-allowed;", "}"], themes_["variables"].interactiveColorBorderDisabled, themes_["variables"].contentColorDisabled, themes_["variables"].interactiveColorBackgroundDisabled, function ($selected) {
  return $selected && Object(external_styled_components_["css"])(["background-color:", ";"], themes_["mixins"].overlayColors(themes_["variables"].interactiveColorBackgroundDisabled, themes_["variables"].interactiveColorOverlaySelected));
});
var prismaFilled = Object(external_styled_components_["css"])(["", " font-weight:", ";border-radius:20px;", " &:not([disabled]){color:", ";transition:background-color 0.2s,box-shadow 0.2s,text-decoration 0.2s;background-color:", ";&:hover,&:focus{background-color:", ";}&:hover{box-shadow:", ";}&:focus{box-shadow:", ";}&:active{background-color:", ";transition:none;}}", ""], common, themes_["variables"].fontWeightSemiBold, appendPrepend, themes_["variables"].contentColorInverted, Object(themes_["pickVariant"])('$selected', {
  "false": Object(themes_["pickVariant"])('$variant', {
    prismaPrimary: themes_["variables"].interactiveColorPrimary,
    prismaDestructive: themes_["variables"].accentColorNegative
  }),
  "true": Object(themes_["pickVariant"])('$variant', {
    prismaPrimary: themes_["mixins"].overlayColors(themes_["variables"].interactiveColorPrimary, themes_["variables"].interactiveColorOverlaySelected),
    prismaDestructive: themes_["mixins"].overlayColors(themes_["variables"].accentColorNegative, themes_["variables"].interactiveColorOverlaySelected)
  })
}), Object(themes_["pickVariant"])('$variant', {
  prismaPrimary: themes_["mixins"].overlayColors(themes_["variables"].interactiveColorPrimary, themes_["variables"].interactiveColorOverlayHover),
  prismaDestructive: themes_["mixins"].overlayColors(themes_["variables"].accentColorNegative, themes_["variables"].interactiveColorOverlayHover)
}), themes_["variables"].hoverShadow, themes_["variables"].focusShadow, Object(themes_["pickVariant"])('$variant', {
  prismaPrimary: themes_["mixins"].overlayColors(themes_["variables"].interactiveColorPrimary, themes_["variables"].interactiveColorOverlayActive),
  prismaDestructive: themes_["mixins"].overlayColors(themes_["variables"].accentColorNegative, themes_["variables"].interactiveColorOverlayActive)
}), disabledFillStyles);
var prismaFlat = Object(external_styled_components_["css"])(["", " font-weight:", ";border-radius:", ";", " &:not([disabled]){color:", ";background-color:", ";transition:background-color 0.2s,box-shadow 0.2s,text-decoration 0.2s;", " &:hover{background-color:", ";box-shadow:", ";}&:active{background-color:", ";transition:none;}&:focus{box-shadow:", ";background-color:", ";}}", ""], common, themes_["variables"].fontWeightSemiBold, themes_["variables"].borderRadius, appendPrepend, themes_["variables"].contentColorActive, themes_["variables"].interactiveColorBackground, function ($selected) {
  return $selected && Object(external_styled_components_["css"])(["background-color:", ";"], themes_["mixins"].overlayColors(themes_["variables"].interactiveColorBackground, themes_["variables"].interactiveColorOverlaySelected));
}, themes_["mixins"].overlayColors(themes_["variables"].interactiveColorBackground, themes_["variables"].interactiveColorOverlayHover), themes_["variables"].hoverShadow, themes_["mixins"].overlayColors(themes_["variables"].interactiveColorBackground, themes_["variables"].interactiveColorOverlayActive), themes_["variables"].focusShadow, themes_["mixins"].overlayColors(themes_["variables"].interactiveColorBackground, themes_["variables"].interactiveColorOverlayHover), disabledFillStyles);

// CONCATENATED MODULE: ./src/ButtonSimple/enterpriseStyles.ts


var primaryBackgroundColor = '#1A8929'; // SUI-2439 to meet WCAG AA compliance

var primarySelectedBackgroundColor = '#235823'; // SUI-2439 to meet WCAG AA compliance

var enterpriseStyles_common = Object(external_styled_components_["css"])(["", " border-radius:", ";cursor:pointer;position:relative;&:focus{z-index:3;}"], themes_["mixins"].reset('block'), themes_["variables"].borderRadius);
var enterpriseStyles_appendPrepend = Object(external_styled_components_["css"])(["", " ", ""], function (_ref) {
  var $append = _ref.$append;
  return $append && Object(external_styled_components_["css"])(["border-top-right-radius:0;border-bottom-right-radius:0;border-right:none;"]);
}, function (_ref2) {
  var $prepend = _ref2.$prepend;
  return $prepend && Object(external_styled_components_["css"])(["border-top-left-radius:0;border-bottom-left-radius:0;"]);
});
var lightShadow = 'inset 0 -1px 0 rgba(0, 0, 0, 0.1)';
var lightSelectedShadow = 'inset 0 1px 0 rgba(0, 0, 0, 0.1)';
var enterpriseDefault = Object(external_styled_components_["css"])(["", ";border:", ";", ";font-weight:", ";&:not([disabled]){background-color:", ";color:", ";transition:background-image 0.2s,border 0.2s,box-shadow 0.2s,text-decoration 0.2s;", ";", " &:hover{background-color:", ";box-shadow:", ";}&:active{transition:none;background-color:", ";border-color:", ";", ";}&:focus{box-shadow:", ",", ";", " ", "}}&[disabled]{cursor:not-allowed;color:", ";background-color:", ";border-color:", ";", "}"], enterpriseStyles_common, Object(themes_["pick"])({
  light: Object(external_styled_components_["css"])(["1px solid ", ""], themes_["variables"].gray60),
  dark: themes_["variables"].border
}), enterpriseStyles_appendPrepend, Object(themes_["pickVariant"])('$variant', {
  enterpriseDefault: 'normal',
  enterpriseSecondary: themes_["variables"].fontWeightSemiBold
}), Object(themes_["pick"])({
  light: themes_["variables"].gray98,
  dark: themes_["variables"].gray45
}), Object(themes_["pick"])({
  light: themes_["variables"].gray45,
  dark: themes_["variables"].white
}), Object(themes_["pick"])({
  light: Object(external_styled_components_["css"])(["box-shadow:", ";"], lightShadow),
  dark: Object(external_styled_components_["css"])(["box-shadow:inset 0 -1px 0 ", ";"], themes_["variables"].gray30)
}), function (_ref3) {
  var $selected = _ref3.$selected;
  return $selected && Object(external_styled_components_["css"])(["box-shadow:", ";background-color:", ";border-color:", ";"], Object(themes_["pick"])({
    light: lightSelectedShadow,
    dark: Object(external_styled_components_["css"])(["inset 0 1px 0 ", ""], themes_["variables"].black)
  }), Object(themes_["pick"])({
    light: themes_["variables"].gray92,
    dark: themes_["variables"].gray22
  }), Object(themes_["pick"])({
    light: themes_["variables"].gray60,
    dark: themes_["variables"].gray20
  }));
}, Object(themes_["pick"])({
  light: '#ebeeef',
  dark: themes_["variables"].gray30
}), Object(themes_["pick"])({
  light: lightShadow,
  dark: Object(external_styled_components_["css"])(["inset 0 -1px 0 ", ""], themes_["variables"].gray25)
}), Object(themes_["pick"])({
  light: themes_["variables"].gray92,
  dark: themes_["variables"].gray22
}), Object(themes_["pick"])({
  light: themes_["variables"].gray60,
  dark: themes_["variables"].gray20
}), Object(themes_["pick"])({
  dark: Object(external_styled_components_["css"])(["box-shadow:inset 0 -1px 0 ", ";"], themes_["variables"].gray22)
}), Object(themes_["pick"])({
  light: lightShadow,
  dark: Object(external_styled_components_["css"])(["inset 0 -1px 0 ", ""], themes_["variables"].gray30)
}), themes_["variables"].focusShadow, function (_ref4) {
  var $append = _ref4.$append;
  return $append && Object(external_styled_components_["css"])(["box-shadow:", ",", ",inset -1px 0 0 ", ";"], Object(themes_["pick"])({
    light: lightShadow,
    dark: Object(external_styled_components_["css"])(["inset 0 -1px 0 ", ""], themes_["variables"].gray30)
  }), themes_["variables"].focusShadow, themes_["variables"].borderColor);
}, function (_ref5) {
  var $append = _ref5.$append,
      $selected = _ref5.$selected;
  return $append && $selected && Object(themes_["pick"])({
    light: Object(external_styled_components_["css"])(["box-shadow:", ",", ",", ",inset -1px 0 0 ", ";"], lightShadow, lightSelectedShadow, themes_["variables"].focusShadow, themes_["variables"].borderColor),
    dark: Object(external_styled_components_["css"])(["box-shadow:inset 0 1px 0 ", ",", ",inset -1px 0 0 ", ";"], themes_["variables"].black, themes_["variables"].focusShadow, themes_["variables"].borderColor)
  });
}, themes_["variables"].textDisabledColor, Object(themes_["pick"])({
  light: themes_["variables"].gray96,
  dark: themes_["variables"].gray30
}), Object(themes_["pick"])({
  light: themes_["variables"].borderLightColor,
  dark: themes_["variables"].gray30
}), function (_ref6) {
  var $selected = _ref6.$selected;
  return $selected && Object(themes_["pick"])({
    light: Object(external_styled_components_["css"])(["box-shadow:", ";background-color:", ";border-color:", ";"], lightSelectedShadow, themes_["variables"].gray92, themes_["variables"].gray80),
    dark: Object(external_styled_components_["css"])(["box-shadow:inset 0 1px 0 ", ";background-color:", ";border-color:", ";"], themes_["variables"].black, themes_["variables"].gray22, themes_["variables"].gray20)
  });
});
var primaryShadow = 'inset 0 -2px 0 rgba(0, 0, 0, 0.1)';
var primarySelectedShadow = 'inset 0 2px 0 rgba(0, 0, 0, 0.1)';
var enterprisePrimary = Object(external_styled_components_["css"])(["", ";font-weight:", ";", " &:not([disabled]){background-color:", ";color:", ";box-shadow:", ";transition:background-image 0.2s,border 0.2s,box-shadow 0.2s,text-decoration 0.2s;", " ", " &:hover{background-color:", ";}&:active{background-color:", ";transition:none;}&:focus{box-shadow:", ",", ";&:active{background-color:", ";transition:none;}}}&[disabled]{color:", ";background-color:", ";cursor:not-allowed;", "}"], enterpriseStyles_common, themes_["variables"].fontWeightSemiBold, enterpriseStyles_appendPrepend, primaryBackgroundColor, themes_["variables"].white, primaryShadow, function (_ref7) {
  var $selected = _ref7.$selected;
  return $selected && Object(external_styled_components_["css"])(["box-shadow:", ";background-color:", ";"], primarySelectedShadow, primarySelectedBackgroundColor);
}, function (_ref8) {
  var $prepend = _ref8.$prepend;
  return $prepend && Object(external_styled_components_["css"])(["border-left:1px solid ", ";"], primaryBackgroundColor);
}, themes_["variables"].brandColorD50, themes_["variables"].brandColorD30, primaryShadow, themes_["variables"].focusShadow, themes_["variables"].brandColorD30, themes_["variables"].brandColorL30, themes_["variables"].brandColorL10, function (_ref9) {
  var $selected = _ref9.$selected;
  return $selected && Object(external_styled_components_["css"])(["box-shadow:", ";background-color:", ";"], primarySelectedShadow, themes_["variables"].brandColorD20);
});
var enterpriseError = Object(external_styled_components_["css"])(["", ";font-weight:", ";", " &:not([disabled]){background-color:", ";color:", ";box-shadow:", ";transition:background-image 0.2s,border 0.2s,box-shadow 0.2s,text-decoration 0.2s;", " ", " &:hover{background-color:", ";}&:active{background-color:", ";transition:none;}&:focus{box-shadow:", ",", ";&:active{background-color:", ";transition:none;}}}&[disabled]{color:", ";background-color:", ";cursor:not-allowed;", "}"], enterpriseStyles_common, themes_["variables"].fontWeightSemiBold, enterpriseStyles_appendPrepend, themes_["variables"].errorColor, themes_["variables"].white, primaryShadow, function (_ref10) {
  var $selected = _ref10.$selected;
  return $selected && Object(external_styled_components_["css"])(["box-shadow:", ";background-color:", ";"], primarySelectedShadow, themes_["variables"].errorColorD20);
}, function (_ref11) {
  var $prepend = _ref11.$prepend;
  return $prepend && Object(external_styled_components_["css"])(["border-left:1px solid ", ";"], themes_["variables"].errorColorD20);
}, themes_["variables"].errorColorD20, themes_["variables"].errorColorD30, primaryShadow, themes_["variables"].focusShadow, themes_["variables"].errorColorD30, themes_["variables"].errorColorL30, themes_["variables"].errorColorL10, function (_ref12) {
  var $selected = _ref12.$selected;
  return $selected && Object(external_styled_components_["css"])(["box-shadow:", ";background-color:", ";"], primarySelectedShadow, themes_["variables"].errorColorD20);
});
var enterprisePill = Object(external_styled_components_["css"])(["", ";color:", ";border:1px solid transparent;&:not([disabled]){transition:background-color 0.2s,border 0.2s,box-shadow 0.2s,text-decoration 0.2s;", " &:hover{color:", ";background-color:", ";border-color:", ";}", " &:focus{color:", ";box-shadow:", ";}&:active,&[aria-expanded='true']{background-color:", ";transition:none;}}&[disabled]{color:", ";cursor:not-allowed;", "}"], enterpriseStyles_common, Object(themes_["pick"])({
  light: themes_["variables"].gray45,
  dark: themes_["variables"].white
}), function (_ref13) {
  var $selected = _ref13.$selected;
  return $selected && Object(external_styled_components_["css"])(["border-color:", ";"], themes_["variables"].accentColor);
}, Object(themes_["pick"])({
  light: themes_["variables"].linkColor,
  dark: themes_["variables"].white
}), themes_["variables"].backgroundColorHover, Object(themes_["pick"])({
  light: themes_["variables"].gray60,
  dark: themes_["variables"].borderColor
}), function (_ref14) {
  var $error = _ref14.$error;
  return $error && Object(external_styled_components_["css"])(["&,&:hover{color:", ";}"], themes_["variables"].errorColor);
}, Object(themes_["pick"])({
  light: themes_["variables"].linkColor,
  dark: themes_["variables"].white
}), themes_["variables"].focusShadow, Object(themes_["pick"])({
  light: themes_["variables"].gray92,
  dark: themes_["variables"].gray22
}), themes_["variables"].textDisabledColor, function (_ref15) {
  var $selected = _ref15.$selected;
  return $selected && Object(external_styled_components_["css"])(["border-color:", ";"], themes_["variables"].borderLightColor);
});

// CONCATENATED MODULE: ./src/ButtonSimple/ButtonSimpleStyles.ts





var StyledClickable = external_styled_components_default()(Clickable_default.a).withConfig({
  displayName: "ButtonSimpleStyles__StyledClickable",
  componentId: "vlarwe-0"
})(["", ""], Object(themes_["pickVariant"])('$variant', {
  enterpriseDefault: enterpriseDefault,
  enterpriseSecondary: enterpriseDefault,
  enterprisePrimary: enterprisePrimary,
  enterpriseError: enterpriseError,
  enterprisePill: enterprisePill,
  prismaDefault: prismaTransparent,
  prismaDestructive: prismaFilled,
  prismaPrimary: prismaFilled,
  prismaSecondary: prismaTransparent,
  prismaToggle: prismaTransparent,
  prismaFlat: prismaFlat
}));

// CONCATENATED MODULE: ./src/ButtonSimple/ButtonSimple.tsx
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







var propTypes = {
  action: external_prop_types_default.a.string,
  appearance: external_prop_types_default.a.oneOf(['default', 'secondary', 'primary', 'destructive', 'pill', 'toggle', 'flat']),
  append: external_prop_types_default.a.bool,
  children: external_prop_types_default.a.node,
  disabled: external_prop_types_default.a.bool,
  elementRef: external_prop_types_default.a.oneOfType([external_prop_types_default.a.func, external_prop_types_default.a.object]),
  inline: external_prop_types_default.a.bool,
  openInNewContext: external_prop_types_default.a.bool,
  prepend: external_prop_types_default.a.bool,
  selected: external_prop_types_default.a.bool,
  splunkTheme: external_prop_types_default.a.object,
  status: external_prop_types_default.a.oneOf(['normal', 'error']),
  to: external_prop_types_default.a.string
};
var defaultProps = {
  appearance: 'default',
  append: false,
  disabled: false,
  inline: true,
  openInNewContext: false,
  prepend: false,
  selected: false,
  status: 'normal'
};

var ButtonSimple_ButtonSimple = /*#__PURE__*/function (_Component) {
  _inherits(ButtonSimple, _Component);

  var _super = _createSuper(ButtonSimple);

  function ButtonSimple() {
    var _this;

    _classCallCheck(this, ButtonSimple);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "component", null);

    _defineProperty(_assertThisInitialized(_this), "handleMount", function (c) {
      _this.component = c;
    });

    return _this;
  }

  _createClass(ButtonSimple, [{
    key: "focus",

    /**
     * Places focus on the button.
     */
    value: function focus() {
      var _this$component;

      (_this$component = this.component) === null || _this$component === void 0 ? void 0 : _this$component.focus();
    }
  }, {
    key: "mapVariant",
    value: function mapVariant() {
      var _this$props = this.props,
          splunkTheme = _this$props.splunkTheme,
          appearance = _this$props.appearance,
          status = _this$props.status;
      var enterprise = {
        "default": 'enterpriseDefault',
        destructive: 'enterpriseDefault',
        primary: 'enterprisePrimary',
        secondary: 'enterpriseSecondary',
        pill: 'enterprisePill',
        toggle: 'enterpriseDefault',
        flat: 'enterpriseDefault'
      };
      var prisma = {
        "default": 'prismaDefault',
        destructive: 'prismaDestructive',
        primary: 'prismaPrimary',
        secondary: 'prismaSecondary',
        pill: 'prismaSecondary',
        toggle: 'prismaToggle',
        flat: 'prismaFlat'
      };

      if (splunkTheme.family === 'enterprise') {
        return status === 'error' ? 'enterpriseError' : enterprise[appearance];
      }

      return prisma[appearance];
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          append = _this$props2.append,
          children = _this$props2.children,
          prepend = _this$props2.prepend,
          selected = _this$props2.selected,
          status = _this$props2.status,
          otherProps = _objectWithoutProperties(_this$props2, ["append", "children", "prepend", "selected", "status"]);

      return /*#__PURE__*/external_react_default.a.createElement(StyledClickable, _extends({
        "aria-invalid": status === 'error' || undefined,
        "data-test": "button-simple",
        ref: this.handleMount,
        $variant: this.mapVariant(),
        $error: status === 'error',
        $append: append,
        $prepend: prepend,
        $selected: selected
      }, otherProps), children, selected && /*#__PURE__*/external_react_default.a.createElement(ScreenReaderContent_default.a, null, Object(i18n_["_"])('Selected')));
    }
  }]);

  return ButtonSimple;
}(external_react_["Component"]);

_defineProperty(ButtonSimple_ButtonSimple, "defaultProps", defaultProps);

_defineProperty(ButtonSimple_ButtonSimple, "propTypes", propTypes);

var ButtonSimpleWithTheme = Object(themes_["withSplunkTheme"])(ButtonSimple_ButtonSimple);
ButtonSimpleWithTheme.propTypes = ButtonSimple_ButtonSimple.propTypes;
/* harmony default export */ var src_ButtonSimple_ButtonSimple = (ButtonSimpleWithTheme);
// CONCATENATED MODULE: ./src/ButtonSimple/index.ts



/***/ }),

/***/ 14:
/***/ (function(module, exports) {

module.exports = require("@splunk/react-ui/ScreenReaderContent");

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("styled-components");

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = require("@splunk/ui-utils/i18n");

/***/ })

/******/ });